import React, { Component } from 'react';
import './AdminEditOrder.css';
import NabarAdmin from '../Components/NabarAdmin/NabarAdmin';
import AdminHeaderTool from '../Components/AdminHeaderTool/AdminHeaderTool';
import MapsNewOrder from '../../Components/Maps/MapsNewOrder';
import searchbule from '../../../image/searchbule.svg'

import calendar from '../../../image/calendar.svg'
import iconrightwhite from '../../../image/iconrightwhite.svg'
import promocode from '../../../image/promocode.svg'
import axios from 'axios'
import {LinkAPI} from '../../../API/API'
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import moment from 'moment';
import HandleRes from '../../Components/HandleRes/HandleRes';


class AdminEditOrder extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data:[],
            categories: [],
            savedlocations: [],
            clients:[],
            usemaps:true,
            balance: "",
            categoryselect: "",
            quantity: "",
            receiver: "",
            phone: "",
            deliverynote: "",
            collectMoney: false,
            amount: 0,
            promocode: "",
            promocodediscount: 0,
            weight: 1,
            payment: "",
            pickupdate:new Date() ,
            pickupaddress_name: "",
            pickupaddress_alias: "",
            address_name: "",
            dropoffaddress_alias: "",
            pickupcoordinates: [],
            coordinates: [],
            weightprice: 16,
            tripPrice: 17,
            orderPrice: 33,
            totalPrice: 33,
            categoryselectError: "",
            quantityError: "",
            receiverError: "",
            phoneError: "",
            collectMoneyError: "",
            amountError: "",
            weightError: "",
            paymentError: "",
            pickupdateError: "",
            pickupaddress_nameError: "",
            pickupaddress_aliasError: "",
            dropoffaddress_nameError: "",
            dropoffaddress_aliasError: "",
            startDate: new Date(),
            networkError: false,
            errordatamessage: false,
            errordatamessagetext: '',
            errordataCodemessage: false,
            errordatamessageCodetext: '',
            hasError: false,

        };
        this.getorderid()
        this.handleChangedate = this.handleChangedate.bind(this);

    }
    handleChangedate(date) {
        let datenew = moment(date).format()
        this.setState({
            pickupdate: datenew,
            startDate: date
        });
    }



getorderid = () => {
    const Token = localStorage.getItem("AdminTokenKayn")
    const id= this.props.match.params.id
    axios.get(`${LinkAPI}/api/admin/getorder/${id}`, {
        headers: {
            Authorization: `${Token}`
        }
    }).then(res => {
        console.log(res)
        this.setState({
            reciver: res.data.order.reciver[res.data.order.reciver.length-1].name,
            phone: res.data.order.reciver[res.data.order.reciver.length-1].phone.replace(/^20+/, ''),
            categoryselect:res.data.order.category,
            quantity: res.data.order.quantity,
            ordernumber: res.data.order.ordernumber,
            deliverynote: res.data.order.note,
            startDate: moment( res.data.order.pickupDate ).toDate(),
            pickupaddress_name: res.data.order.pickupLocation.address_name,
            pickupaddress_alias: res.data.order.pickupLocation.address_alias,
            pickupcoordinates: res.data.order.pickupLocation.location.coordinates,
            address_name: res.data.order.dropoffLocation[res.data.order.dropoffLocation.length-1].address_name,
            dropoffaddress_alias: res.data.order.dropoffLocation[res.data.order.dropoffLocation.length-1].address_alias,
            coordinates: res.data.order.dropoffLocation[res.data.order.dropoffLocation.length-1].location.coordinates,
            orderPrice:res.data.order.orderPrice,
            amount: res.data.order.amount,
            weight: res.data.order.weight,
            totalPrice: res.data.order.totalPrice,
            status: res.data.order.status,
            amount: res.data.order.amount,
            balance:res.data.order.ownerData.balance,
            categories:res.data.categories
        })  

        if( res.data.order.promocodeused){
            this.setState({promocode:res.data.order.promocodeused})
            this.getCouponbyname(res.data.order.promocodeused)
            
        }

        if(this.state.amount!==null&&this.state.amount!==0){
            this.setState({collectMoney:true})
        }

        
        

    }).catch(error => {
        this.HandleError(error)
    })
}
HandleError = (error) => {
    if (!error.response) {
        this.setState({
            networkError: true
        })
    } else if (error.response.status === 402) {
        window.location.replace("/Admin/SignIn");
    } else if (error.response.data.message) {
        this.setState({
            errordatamessage: true,
            errordatamessagetext: error.response.data.message,
            categoryselectError: "",
            quantityError: "",
            reciverError: "",
            phoneError: "",
            collectMoneyError: "",
            amountError: "",
            weightError: "",
            paymentError: "",
            pickupdateError: "",
            pickupaddress_nameError:"",
            pickupaddress_aliasError:"",
            dropoffaddress_nameError:"",
            dropoffaddress_aliasError:"",
        })
    } else {
        this.setState({
            hasError: true,
        })
    }
}
getCouponbyname =(x)=>{
    const Token = localStorage.getItem("AdminTokenKayn")

    const name = x
        axios.get(`${LinkAPI}/api/admin/getpromocode/${name}`,{
            headers:{
            Authorization:`${Token}`
            }
        }).then(res =>{
            this.setState({
                    promocodediscount:res.data.amount,
            })
            
            
            }).catch(error=>{
            })
    }
handleChangecheckbox = event => {
    const isCheckbox = event.target.type === "checkbox";
    this.setState({
        [event.target.name]: isCheckbox
            ? event.target.checked
            : event.target.value,
            amount:0
    });

};
calcularorTotal = event => {
    this.setState({
        [event.target.name]: event.target.value
    });

    let weightprice = this.state.weightprice
    let tripPrice = this.state.tripPrice
    let promocodediscount = this.state.promocodediscount
    let weight = event.target.value
    let orderPrice = tripPrice + (weight * weightprice)
    let totalPrice = (tripPrice + (weight * weightprice)) - promocodediscount

    this.setState({
        orderPrice: orderPrice,
        totalPrice: totalPrice
    })
}

handleChange = event => {
    const isCheckbox = event.target.type === "checkbox";
    this.setState({
        [event.target.name]: isCheckbox
            ? event.target.checked
            : event.target.value
    });

};
setStatecoordinatesaddress_aliaspickup = (pickupcoordinates,pickupaddress_name)  =>{
    this.setState({
        pickupcoordinates: pickupcoordinates,
        pickupaddress_name: pickupaddress_name

    })

}
setStatecoordinatesaddress_alias = (coordinates,address_name)  =>{
    this.setState({
        coordinates: coordinates,
        address_name: address_name

    })

}
    validate = () => {
        let quantityError = "";
        let reciverError = "";
        let phoneError = "";
        let amountError = "";
        let weightError = "";
        let categoryselectError = "";
        let paymentError = "";
        let collectMoneyError = "";
        let pickupdateError = "";
        let pickupaddress_nameError="";
        let pickupaddress_aliasError="";
        let dropoffaddress_nameError="";
        let dropoffaddress_aliasError="";
        if (isNaN(this.state.quantity) || this.state.quantity < 1) {
            quantityError = "write quantity";
        }
        if (isNaN(this.state.phone)|| this.state.phone.length < 10 ||this.state.phone.length > 11) {
            phoneError = "write phone Numper ";
        }
        if (this.state.categoryselect === "") {
            categoryselectError = "select vehicle type ";
        }
        // if (this.state.pickupdate !== Date) {
        //     pickupdateError = "invalid Date";
        // }
        
        if (this.state.collectMoney === true) {
            if (isNaN(this.state.amount) || this.state.amount < 1) {
                amountError = "wrong amount ";
            }
        }
        if (this.state.reciver.length < 2||!isNaN(this.state.pickupaddress_name)) {
            reciverError = "write receiver name";
        }
        if (isNaN(this.state.weight) || this.state.quantity < 1) {
            weightError = "write weight ";
        }
        
        if (this.state.collectMoney !== false && this.state.collectMoney !== true) {
            collectMoneyError = "wrong";
        }
        
        if (this.state.pickupaddress_name.length < 2||!isNaN(this.state.pickupaddress_name)) {
            pickupaddress_nameError = "select your location correct";
        }
        if (!this.state.pickupcoordinates) {
            pickupaddress_nameError = "select your location correct";
        }
        if (this.state.pickupaddress_alias.length < 2||!isNaN(this.state.address_alias)) {
            pickupaddress_aliasError = "write your Address correct";
        }
        if (this.state.address_name.length < 2||!isNaN(this.state.address_name)) {
            dropoffaddress_nameError = "select your location correct";
        }
        if (!this.state.coordinates) {
            dropoffaddress_nameError = "select your location correct";
        }
        if (this.state.dropoffaddress_alias.length < 2||!isNaN(this.state.dropoffaddress_alias)) {
            dropoffaddress_aliasError = "write your Address correct";
        }
        if (quantityError || phoneError || reciverError || weightError || categoryselectError || paymentError || collectMoneyError || amountError || pickupdateError || pickupaddress_nameError || pickupaddress_aliasError|| dropoffaddress_nameError || dropoffaddress_aliasError) {
            this.setState({ quantityError, phoneError, reciverError, weightError, categoryselectError, paymentError, collectMoneyError, amountError, pickupdateError ,pickupaddress_nameError ,pickupaddress_aliasError,dropoffaddress_nameError,dropoffaddress_aliasError});
            return false;
        }

        return true;
    };

 
    handleSubmitEditOrder = event => {
        event.preventDefault();
        const {categoryselect,quantity,reciver,phone,deliverynote,orderPrice,totalPrice,amount,weight,payment,pickupdate,pickupaddress_name,pickupaddress_alias,address_name,dropoffaddress_alias,pickupcoordinates,coordinates}= this.state
        const Token =localStorage.getItem("AdminTokenKayn")
        const id= this.props.match.params.id
        const isValid = this.validate();
        if (isValid) {
            // clear form
            axios.put(`${LinkAPI}/api/admin/modifyorder/${id}`,{
                category:categoryselect,
                   quantity:quantity,
                   pickupDate:pickupdate,
                   pickupLocation:{
                       address_name:pickupaddress_name,
                       address_alias:pickupaddress_alias,
                       location:{
                           coordinates:pickupcoordinates
                       }
                   },
                   dropoffLocation:{
                       address_name:address_name,
                       address_alias:dropoffaddress_alias,
                       location:{
                           coordinates:coordinates
                       }
                   },
                   note:deliverynote,
                   orderPrice:orderPrice,
                   totalPrice:totalPrice,
                   reciver:{
                       name:reciver,
                       phone:20+phone.replace(/^0+/, '')
                   },
                   payment:payment,
                   amount:amount,
                   weight:weight
            },{
                headers:{
                  Authorization:`${Token}`
                }
              } 
              ).then(res =>{
                // window.location.replace("/Admin/Orders");
                this.props.history.push("/Admin/Orders")
            }).catch(error=>{
                if (!error.response) {
                    this.setState({
                        networkError: true
                    })
                } else if (error.response.status === 402) {
                    window.location.replace("/Admin/SignIn");
                } else if (error.response.data.message) {
                    this.setState({
                        errordatamessage: true,
                        errordatamessagetext: error.response.data.message
                    })
                } else {
                    this.setState({
                        hasError: true,
                    })
                }
                })
        }
    };
   

    
    render() {
        return (
            <div>
                <div className="AppEN container-fluid px-0">
                    <div className="row   mx-0">
                        <div className="col-md-1 px-0 ">
                            <NabarAdmin />
                        </div>
                        <div className="client col-md-11 px-lg-5">
                            <AdminHeaderTool />
                            <h3 className=" fontsize9 my-2"> MODIFY ORDER</h3>
                            <div className="AdminEditOrder  m-3 p-3 shadow rounded">
                                <form id="createorders" >
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group  ">
                                                <select className={"form-control badge-pill text-muted" + (this.state.categoryselectError ? ' is-invalid' : '')} name="categoryselect" value={this.state.categoryselect} onChange={this.handleChange} >
                                                    <option  >PRODUCT CATEGORY ...</option>
                                                    
                                                    {
                                                        this.state.categories.map((x, i) => (
                                                        <option key={i} value={x}>{x}</option>

                                                        ))
                                             }
                                                </select>
                                                <div style={{ fontSize: 12, color: "red", textAlign: "center" }}>
                                                    {this.state.categoryselectError}
                                                </div>

                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group  ">
                                                <input type="text" className={"form-control badge-pill " + (this.state.quantityError ? 'is-invalid' : '')} placeholder="Product Quantity" name="quantity" value={this.state.quantity} onChange={this.handleChange} />
                                                <div style={{ fontSize: 12, color: "red", textAlign: "center" }}>
                                                    {this.state.quantityError}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-4 text-center mb-2">
                                            <div className="form-group has-search  mb-0 pt-2">
                                                <span className="fontsize11 font-weight-bold m-1 ">Pick up date</span>
                                                <img className="mx-1" src={calendar} alt="calendars" />

                                                
                                                
                                                <DatePicker
                                                className="badge-pill btn border"
                                                dateFormat="MMMM d, yyyy "
                                                selected={this.state.startDate}
                                                onChange={date =>this.handleChangedate(date)}
                                                minDate={new Date()}
                                                placeholderText="Select a date"
                                            /> 
                                            </div>
                                            <div style={{ fontSize: 12, color: "red", textAlign: "center" }}>
                                                    {this.state.pickupdateError}
                                                </div>
                                        </div>
                                        
                                        {/* map */}

                                        <MapsNewOrder key={this.state.ordernumber} state={this.state} setStatecoordinatesaddress_aliaspickup={this.setStatecoordinatesaddress_aliaspickup} setStatecoordinatesaddress_alias={this.setStatecoordinatesaddress_alias} />
                                        <div className="col-md-6 px-lg-5 text-center">
                                            <div className="form-group mb-2 p-0 search_div" id="pac-container2">
                                                <img className="mr-1 img_input" src={searchbule} alt="search" />
                                                <input type="text " id="pac-input2" className={"px-5 search_input form-control badge-pill " + (this.state.pickupaddress_nameError ? 'is-invalid' : '')} placeholder="PICK UP LOCATION" name="pickupaddress_name" value={this.state.pickupaddress_name} onChange={this.handleChange} />
                                                
                                            </div>
                                            <div className="mb-2" style={{ fontSize: 12, color: "red" }}>
                                                    {this.state.pickupaddress_nameError}
                                                </div>
                                            <div id="map2"></div>
                                            <div className="form-group col-12 text-left mt-2">
                                                <input type="text" className={"px-5 search_input form-control badge-pill " + (this.state.pickupaddress_aliasError ? 'is-invalid' : '')} placeholder="Adrress Details" name="pickupaddress_alias" value={this.state.pickupaddress_alias} onChange={this.handleChange} />
                                                <div className="mx-5 px-5" style={{ fontSize: 12, color: "red" }}>
                                                    {this.state.pickupaddress_aliasError}
                                                </div>
                                            </div>

                                        </div>
                                        <div className="col-md-6 px-lg-5 text-center">
                                            <div className="form-group mb-2 p-0 search_div" id="pac-container">
                                                <img className="mr-1 img_input " src={searchbule} alt="search" />
                                                <input type="text" id="pac-input" className={"px-5 search_input form-control badge-pill " + (this.state.dropoffaddress_nameError ? 'is-invalid' : '')}  placeholder="DROP OFF LOCATION" name="address_name" value={this.state.address_name} onChange={this.handleChange}/>
                                                
                                            </div>
                                            <div className="mb-2" style={{ fontSize: 12, color: "red" }}>
                                                    {this.state.dropoffaddress_nameError}
                                                </div>
                                            <div id="map"></div>
                                            <div className="form-group col-12 text-left mt-2">
                                                <input type="text" className={"form-control badge-pill p-3 " + (this.state.dropoffaddress_aliasError ? 'is-invalid' : '')} placeholder="Adrress Details" name="dropoffaddress_alias" value={this.state.dropoffaddress_alias} onChange={this.handleChange} />
                                                <div className="mx-5 px-5" style={{ fontSize: 12, color: "red" }}>
                                                    {this.state.dropoffaddress_aliasError}
                                                </div>
                                            </div>
                                        </div> 

                                        <div className="col-md-4  my-3">
                                            <div className="form-group  ">
                                                <input type="text" className={"form-control badge-pill " + (this.state.reciverError ? 'is-invalid' : '')} placeholder="RECEIVER" name="reciver" value={this.state.reciver} onChange={this.handleChange} />
                                                <div style={{ fontSize: 12, color: "red", textAlign: "center" }}>
                                                    {this.state.reciverError}
                                                </div>
                                            </div>
                                            <div className="form-group  ">
                                            <div className="relative">
                            <span className="codephone">+20</span>
                                                <input type="number" className={"form-control badge-pill pl-5" + (this.state.phoneError ? 'is-invalid' : '')} placeholder="PHONE NUMER" name="phone" value={this.state.phone} onChange={this.handleChange} />
                                                </div>

                                                <div style={{ fontSize: 12, color: "red", textAlign: "center" }}>
                                                    {this.state.phoneError}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4  my-3">
                                            <div className="form-group  ">
                                                <textarea className="form-control" id="exampleFormControlTextarea1" rows="3" placeholder="DELIVERYNOTE"  name="deliverynote" value={this.state.deliverynote} onChange={this.handleChange}></textarea>

                                            </div>
                                        </div>

                                        <div className="col-md-4  my-3">
                                            <div className="form-check text-center mb-3">
                                                <input className="form-check-input" type="checkbox" id="gridCheck1" name="collectMoney" value={this.state.collectMoney}onChange={this.handleChangecheckbox}  checked={(this.state.collectMoney===true?'checked':'')}/>
                                                <label className="form-check-label" htmlFor="gridCheck1" >
                                                    Collect money from the receiver
                                        </label>
                                                <div style={{ fontSize: 12, color: "red", textAlign: "center" }}>
                                                    {this.state.collectMoneyError}
                                                </div>
                                            </div>
                                            <div className="form-group  ">
                                                <input type="text" className={"form-control badge-pill" + (this.state.amountError ? ' is-invalid' : '')} placeholder="AMOUNT" name="amount" value={this.state.amount}  onChange={this.handleChange}
                                                    disabled={(this.state.collectMoney ? '' : 'disabled')}
                                                />
                                                <div style={{ fontSize: 12, color: "red", textAlign: "center" }}>
                                                    {this.state.amountError}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <h3 className=" fontsize9  mx-3">Payment details</h3>
                                    <hr />
                                    <div className=" px-3">
                                        
                                        <div className="col-md-5  px-2 text-center"> 
                                    
                                            <div className="form-group    search_div" disabled>
                                                <input disabled type="text" className="form-control badge-pill pl-7" placeholder="PROMO CODE" name="promocode" value={this.state.promocode}  />
                                                <img className="img_promocode" src={promocode} alt="promocode" />
                                                <a disabled className="btn badge-pill px-2 btnpromocodo my-1  text-white  bluebg">check</a>
                                                
                                            </div>
                                            <div className="form-group ">
                                                <input type="number" className={"form-control badge-pill " + (this.state.weightError ? 'is-invalid' : '')} title="text text text texttext text  " placeholder="Weight .kg" name="weight"  value={this.state.weight}  onChange={this.calcularorTotal} />
                                                <div style={{ fontSize: 12, color: "red" }}>
                                                    {this.state.weightError}
                                                </div>
                                            </div>


                                        </div>
                                        <div className="col-md-6 px-3 ">
                                            <p className="m-0  mt-3" >Sub-total : <span className="float-right"> {this.state.orderPrice} EGP</span></p>
                                            {(this.state.promocodediscount === 0 ?
                                                ''       
                                                : 
                                                <p className="text-danger" >Promotions : <span className=" float-right">-{this.state.promocodediscount} EGP</span></p>
                                                )}
                                        </div>
                                    </div>
                                    <hr />
                                    <p className=" col-md-6   mt-3 fontsize9 font-weight-bold " >TOTAL : <span className=" fontsize9 font-weight-bold  float-right">{this.state.totalPrice} EGP</span></p>
                                    <div className="text-center d-sm-flex justify-content-sm-around  flex-wrap my-3">
                                        <button onClick={this.handleSubmitEditOrder} className="text-white badge-pill p-2 pl-1 px-3 my-1 border shadow bluebg "><img className="mr-1" src={iconrightwhite} alt="rightwhite" /> EDIT ORDER</button>
                                        {/* <button   className=" text-white  btn badge-pill p-2 pl-1 px-3 my-1 border shadow bg-danger" ><img className="mr-1 " src={closeicon} alt="close" /> CANCEL ORDER </button> */}
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                {(this.state.networkError ? <HandleRes title="You are currently offline." stylecss="alert-danger" /> : '')}
                {(this.state.errordatamessage ? <HandleRes title={this.state.errordatamessagetext} stylecss="alert-danger" /> : '')}
                {(this.state.hasError ? <HandleRes title="sorry there was a problem with your request" stylecss="alert-danger" /> : '')}

            </div>
        )
    }
}


export default AdminEditOrder;